.bl{flex-shrink:0;}